import { forwardRef } from 'react'

import NewsletterForm from '../../newsletter-forms'

import styles from './index.module.scss'

export const TalentNewsletterSections = forwardRef<HTMLElement>((_, ref) => {
  return (
    <section className={styles['section-wrapper']} ref={ref}>
      <div className={styles['content']}>
        <h2 className={styles['title']}>
          Join our <span className={styles['highlight']}>newsletter</span>
        </h2>
        <p className={styles['description']}>International career content straight to your inbox</p>
        <NewsletterForm className={styles['form']} />
      </div>
    </section>
  )
})

export default TalentNewsletterSections
